import { motion } from "framer-motion";
import { useEffect } from "react";
import { useStore } from "../stores";
import { ApartmentBox } from "./ApartmentBox";
import { ContactBox } from "./ContactBox";
import { GetStartedBox } from "./GetStartedBox";
import { HouseBox } from "./HouseBox";
import { SupportBox } from "./SupportBox";

export const Popup = () => {
  const [
    selectedUseplaceId,
    resetSelectedUseplace,
    getAvailableProducts,
    availableProducts,
    resetSearch,
    resetResults,
  ] = useStore((state) => [
    state.selectedUseplaceId,
    state.resetSelectedUseplace,
    state.getAvailableProducts,
    state.availableProducts,
    state.reset,
    state.resetResults,
  ]);

  useEffect(() => {
    if (selectedUseplaceId) {
      getAvailableProducts(selectedUseplaceId);
    }
  }, [selectedUseplaceId]);

  const handleUserKeyPress = (event: KeyboardEvent) => {
    switch (event.key) {
      case "Escape":
        resetSelectedUseplace();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleUserKeyPress);
    return () => {
      window.removeEventListener("keydown", handleUserKeyPress);
    };
  }, [handleUserKeyPress]);
  if (!availableProducts) return null;

  const { useplace } = availableProducts;
  console.log("🏠", useplace);
  console.log("👩", availableProducts);
  const isHouse = useplace.type === "house";
  return (
    <>
      <motion.div
        className="z-20 bg-black/75 fixed top-0 left-0 w-full h-screen"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        onClick={resetSelectedUseplace}
      />

      <motion.div
        className="fixed top-1/2 left-1/2 z-30 shadow-xl z-100  rounded-sm bg-white -translate-x-1/2 -translate-y-1/2 "
        layout
        layoutId="resultWrapper"
      >
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          whileHover={{ scale: 1.1 }}
          className="cursor-pointer w-8 h-8 flex items-center justify-center font-black text-white bg-black rounded-full fixed -top-1 -right-1"
          onClick={() => {
            resetSearch();
            resetResults();
            resetSelectedUseplace();
          }}
        >
          X
        </motion.div>
        <div className="overflow-scroll w-full p-8 flex flex-col gap-8 max-h-[80dvh] ">
          <div className="rounded md:overflow-hidden md:h-10 flex flex-col md:grid md:grid-cols-[150px_1fr] text-sm">
            <div className="bg-secondary-600 text-white flex justify-center items-center">
              {useplace.site.installation === "installed"
                ? "Ansluten"
                : "Ej ansluten"}
            </div>
            <div className="bg-secondary-500 text-white px-4 flex justify-between items-center">
              <div>
                {useplace.address} {useplace.streetno}
                {useplace.floor},{" "}
                {useplace.apartment && "Lgh " + useplace.apartment + ", "}{" "}
                {useplace.zip} {useplace.city}
              </div>
              <div className="cursor-pointer" onClick={resetSelectedUseplace}>
                Ny sökning
              </div>
            </div>
          </div>
          {/* **************************** */}
          {/* Window 1 */}
          {/* **************************** */}
          {isHouse ? (
            <HouseBox availableProducts={availableProducts} />
          ) : (
            <ApartmentBox availableProducts={availableProducts} />
          )}
          {/* **************************** */}
          {/* Window 2 */}
          {/* **************************** */}
          <div className="flex flex-col md:grid md:grid-cols-3 gap-8 text-xs">
            {isHouse ? (
              <GetStartedBox
                useplaceType={useplace.type}
                installed={useplace.site.installation}
              />
            ) : (
              <>
                {availableProducts.results.length > 0 ? (
                  <a
                    href={`/order/?q=${availableProducts.useplace.id}`}
                    className="text-gray-800 hover:underline"
                  >
                    <div className="uppercase text-xs">
                      Beställa mediaomvandlare?
                    </div>
                    <div>
                      Har du beställt TV hos en TV-leverantör och de har
                      informerat dig om att du behöver en mediaomvandlare?
                      Beställ din utrustning här.
                    </div>
                  </a>
                ) : null}
              </>
            )}
            <SupportBox
              useplaceType={useplace.type}
              installed={useplace.site.installation}
            />
            <ContactBox />
            {/* <a
              href={`https://l2.prod.f77.dev/kundservice/kom-igang/${
                useplace.type === "house" ? "villa" : "lagenhet"
              }`}
            >
              <div className="flex flex-col">
                <span>Nyss blivit ansluten</span>
                <span className="text-lg">Kom igång med dina tjänster</span>
                <p>
                  Tjänsteleverantörerna i stadsnätet erbjuder tjänster inom
                  internet, TV och telefoni. Här kan du läsa mer om vilka som
                  finns och hur du kommer igång med dina tjänster.
                </p>
              </div>
            </a>
            <a
              href={`https://l2.prod.f77.dev/kundservice/felsokning/${
                useplace.type === "house" ? "villa" : "lagenhet"
              }`}
            >
              <div className="flex flex-col">
                <span>support/felanmälan</span>
                <span className="text-lg">
                  Upplever du problem med din uppkoppling?
                </span>
                <p>
                  Här guidar vi dig i din felsökning och skulle du fortfarande
                  uppleva problem kontakta din tjänsteleverantör.
                </p>
              </div>
            </a> */}
            <div />
          </div>
        </div>
      </motion.div>
    </>
  );
};
